import store from "@/store"

class Hls {
  constructor() {
    this.init = false
    this._media = null
    this._status = 0
  }
  _init = async () => {
    if (this.init) return true

    _$.vue.$on("mediaEnded", async () => {
      if (!__.media.getLoop()) return false
      if (__.platform.hasBackground()) __.platform.background(store.state.background.slides, __.media.getSource())
      else __.media.play(__.media.getSource(), true)
    })

    this.init = true
    return true
  }

  start = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    hcap.Media.startUp({
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })

    /* Library Code */

    return promise.done
  }
  destroy = async () => {
    if (this._status) await this.stop()

    let promise = await _$.progress.create()

    /* Library Code */
    hcap.Media.shutDown({
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  play = async () => {
    const promise = await _$.progress.create(_$.progress.type.PLAY)
    if (promise.isResolved) return false

    _$.nav.disable()

    if (this._status) await this.stop()
    promise.terminateAfter(8000)

    /* Library Code */
    this._media = hcap.Media.createMedia({
      url: __.media.getSource(),
      mimeType: __.media.getSource().includes(".m3u8") ? "application/x-mpegURL" : __.media.getSource().includes(".mp3") ? "audio/mp3" : "video/mp4"
    })

    this._media.play({
      repeatCount: 1,
      onSuccess: () => (this._status = 1),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done.finally(() => _$.nav.enable())
  }
  stop = async () => {
    let promise = await _$.progress.create(_$.progress.type.STOP)
    if (!this._media || !this._status) {
      promise.reject()
      return false
    }

    let stopPromise = await _$.progress.create(),
      destroyPromise = await _$.progress.create()

    /* Library Code */
    this._media.stop({
      onSuccess: () => stopPromise.resolve(),
      onFailure: payload => stopPromise.reject(payload.errorMessage)
    })
    /* Library Code */

    const stopRes = await stopPromise.done

    /* Library Code */
    this._media.destroy({
      onSuccess: () => destroyPromise.resolve(),
      onFailure: payload => destroyPromise.reject(payload.errorMessage)
    })
    /* Library Code */

    await destroyPromise.done

    this._status = 0
    await _$.sleep(500)

    if (!stopRes) {
      hcap.Media.shutDown({
        onSuccess: async () => {
          hcap.Media.startUp({
            onSuccess: () => promise.resolve(),
            onFailure: () => promise.resolve()
          })
        },
        onFailure: () => promise.resolve()
      })
    } else promise.resolve()

    _$.handler.emit("media_event_received", "play_stop")

    return promise.done
  }
  pause = async () => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    /* Library Code */
    this._media.pause({
      onSuccess: () => {
        promise.resolve()
        _$.handler.emit("media_event_received", "play_pause")
      },
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  continue = async () => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    /* Library Code */
    this._media.resume({
      onSuccess: () => {},
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    _$.vue.$once("mediaPlaying", () => promise.resolve())

    return promise.done
  }

  /* Control Helpers */
  isSeekable = async () => {
    if (!this._status) return false

    /* Library Code */
    const res = await this.getDuration()
    /* Library Code */

    return res ? true : false
  }
  getDuration = async () => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    /* Library Code */
    this._media.getInformation({
      onSuccess: payload => promise.resolve(payload.contentLengthInMs),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let duration = await promise.done
    if (duration) duration = Math.floor(duration / 1000)

    return duration
  }
  getPosition = async () => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    /* Library Code */
    this._media.getPlayPosition({
      onSuccess: payload => promise.resolve(payload.positionInMs),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let position = await promise.done
    if (position) position = Math.floor(position / 1000)

    return position
  }
  setPosition = async second => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    if (__.media.isPaused()) await this.continue()
    /* Library Code */
    this._media.setPlayPosition({
      positionInMs: parseInt(second * 1000),
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    promise.resolve([])

    return promise.done
  }
  setSubtitle = async pid => {
    if (!this._status) return false
    if (pid === "0") return this.closeSubtitle()

    let promise = await _$.progress.create()

    /* Library Code */
    this._media.setSubtitleUrl({
      subtitleUrl: pid,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    const res = await promise.done
    if (!res) return false

    promise = await _$.progress.create()

    /* Library Code */
    this._media.setSubtitleOn({
      subtitleOn: true,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  closeSubtitle = async () => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    /* Library Code */
    this._media.setSubtitleOn({
      subtitleOn: false,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }

  getLanguages = async () => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    /* Library Code */
    this._media.getAudioLanguage({
      onSuccess: payload => promise.resolve(payload.list),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    let languages = await promise.done
    if (!languages) return false

    languages = languages.split(",").map((language, index) => {
      return { key: index.toString(), value: language }
    })

    if (languages.length <= 1) return false

    return languages
  }
  setLanguage = async pid => {
    if (!this._status) return false
    const promise = await _$.progress.create()

    /* Library Code */
    this._media.setAudioLanguage({
      index: parseInt(pid),
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
}

export default Hls
